import { render, staticRenderFns } from "./org-people-dialog.vue?vue&type=template&id=42e90954&scoped=true"
import script from "./org-people-dialog.vue?vue&type=script&lang=js"
export * from "./org-people-dialog.vue?vue&type=script&lang=js"
import style0 from "./org-people-dialog.vue?vue&type=style&index=0&id=42e90954&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e90954",
  null
  
)

export default component.exports